module.exports = __webpack_public_path__ + "static/media/Signup_background.8be22ddb.webp";